import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class OrderPricesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'articles': [
                    {
                        'article_code': '1a2c',
                        'comercial_discount': 0.0,
                        'quantity': 5,
                        'tax_price': 1050.0,
                        'total_price': 5000.0,
                        'unit_price': 1000.0,
                        'item_price': 100.0
                    }
                    ],
                'articles_total_price': 5000.0,
                'total': 6050.0,
                'total_vat': 1050.0,
                'total_gross_income_taxes': 10.0
            },
            errors: []
        }
    }

    orderPrices() {
        const order_prices = this.content();

        return {
            articles: order_prices.articles.map(article => {{
                return {
                        articleCode: article.article_code,
                        comercialDiscount: article.comercial_discount,
                        quantity: article.quantity,
                        taxPrice: article.tax_price,
                        totalPrice: article.total_price,
                        unitPrice: article.unit_price,
                        itemPrice: article.item_price
                    }
            }}),
            articlesTotalPrice: order_prices.articles_total_price,
            total: order_prices.total,
            totalVAT: order_prices.total_vat,
            totalGrossIncomeTaxes: order_prices.total_gross_income_taxes
        }
    }
}